const LinkType = {
    DEFAULT: 'default',
    INTERN: 'intern',
    EXTERN: 'extern',
    PRODUCT: 'product',
    MODAL: 'modal',
    ASSET: 'asset',
    TEL: 'tel',
    EMAIL: 'mailto',
};

export { LinkType };
